<!-- 

 <app-loader class="loader" [ngStyle]="{'display':displayStyles}"></app-loader>
<div style="position: fixed; top: 0; width: 100%; z-index: 10;">
  <app-navbar></app-navbar>
</div>
<div class="foot" style="padding-top: 10rem;">
  <div class="heading-rounds-white">
    <h2>
      <span class="headi">MEDIA</span> &nbsp;
      <span class="headiblue">PRESENCE</span>
    </h2>
  </div>
  <div class="container">
    <div class="tf-step wow fadeInUp" data-wow-delay="0.2s">
      <div style="text-align: center;">
        <a href="https://link1.com" target="_blank">
          <img class="inner-img" src="path/to/image1.jpg" />
        </a>
      </div>
      <div class="img-text">
        <p>Description for image 1</p>
      </div>
    </div>
    <div class="tf-step wow fadeInUp" data-wow-delay="0.2s">
      <div style="text-align: center;">
        <a href="https://link2.com" target="_blank">
          <img class="inner-img" src="path/to/image2.jpg" />
        </a>
      </div>
      <div class="img-text">
        <p>Description for image 2</p>
      </div>
    </div>
    <div class="tf-step wow fadeInUp" data-wow-delay="0.2s">
      <div style="text-align: center;">
        <a href="https://link3.com" target="_blank">
          <img class="inner-img" src="path/to/image3.jpg" />
        </a>
      </div>
      <div class="img-text">
        <p>Description for image 3</p>
      </div>
    </div>
    <div class="tf-step wow fadeInUp" data-wow-delay="0.2s">
      <div style="text-align: center;">
        <a href="https://link4.com" target="_blank">
          <img class="inner-img" src="path/to/image4.jpg" />
        </a>
      </div>
      <div class="img-text">
        <p>Description for image 4</p>
      </div>
    </div>
	<div class="large-card">
	
			<a href="https://image-link.com" target="_blank" class="large-card-image">
				<img src="path/to/large-image.jpg" alt="Large Image" />
			  </a>
			  <a href="https://text-link.com" target="_blank" class="large-card-desc">
		  <p>
			This is the description for the large card. It covers 33% of the width.
			You can add more content here as needed.
		  </p>
		</a>
	  </div>
  </div>
  <app-footer></app-footer>
</div> -->

<!-- <div class="large-card">

    <a href="https://image-link.com" target="_blank" class="large-card-image">
      <img src="path/to/large-image.jpg" alt="Large Image" />
      </a>
      <a href="https://text-link.com" target="_blank" class="large-card-desc">
    <p>
    This is the description for the large card. It covers 33% of the width.
    You can add more content here as needed.
    </p>
  </a>
  </div> -->



<div class="body">
  <app-navbar></app-navbar>
<div>

  <div class="heading-rounds-white">
      <h1><span class="headi">MEDIA PRESENCE</span> </h1>
  </div>
  <div class="criteria">
      <!-- <div *ngFor="let lis of lift" > -->
          <div class="new">
              <div class="new2">
                  <div class="imx">
                
                      <img src="assets/images/inc42.png" alt="">
                
                  </div>
                  <div class="header">
                  </div>
                  <div  class="new3">
                    <a href="https://inc42.com/buzz/iit-bombays-eureka-is-back-offers-prizes-worth-120k-to-aspiring-entrepreneurs/" target="_blank">
                      <p>IIT-Bombay’s Eureka! Is Back: Offers Prizes Worth $120K To Aspiring Entrepreneurs</p>
                    </a>
              </div>
              <div class="knowmore">
                  <div class="butbut" >
                      <p class="know-more" > &nbsp; INC 42 &nbsp;</p>
                  </div>
              </div>
              </div>
          </div>
          <div class="new">
            <div class="new2">
                <div class="imx">
              
                    <img src="assets/images/etimes.jpg" alt="">
              
                </div>
                <div class="header">
                </div>
                <div  class="new3">
                  <a href="https://auto.economictimes.indiatimes.com/news/industry/iit-bombays-eureka-2023-the-biggest-opportunity-for-startup-founders/104704022" target="_blank">
                    <p>IIT Bombay’s Eureka! 2023: The biggest opportunity for startup founders</p>
                  </a>
            </div>
            <div class="knowmore">
                <div class="butbut" >
                    <p class="know-more" > &nbsp; ECONOMIC TIMES &nbsp;</p>
                </div>
            </div>
            </div>
        </div>
        <div class="new">
          <div class="new2">
              <div class="imx">
            
                  <img src="assets/images/theprint.jpg" alt="">
            
              </div>
              <div class="header">
              </div>
              <div  class="new3">
                <a href="https://theprint.in/ani-press-releases/e-cell-iit-bombay-launches-eureka-2023-asias-largest-business-model-competition/1807044/" target="_blank">
                  <p>E-Cell IIT Bombay launches Eureka! 2023: Asia’s largest business model competition</p>
                </a>
          </div>
          <div class="knowmore">
              <div class="butbut" >
                  <p class="know-more" > &nbsp; THE PRINT &nbsp;</p>
              </div>
          </div>
          </div>
      </div>
      <div class="new">
        <div class="new2">
            <div class="imx">
          
                <img src="assets/images/TGH.png" alt="">
          
            </div>
            <div class="header">
            </div>
            <div  class="new3">
              <a href="https://theglobalhues.com/e-cell-iit-bombays-eureka-2022-road-to-success/" target="_blank">
                <p>E-Cell IIT Bombay’s Eureka! 2022 – Road to success</p>
              </a>
        </div>
        <div class="knowmore">
            <div class="butbut" >
                <p class="know-more" > &nbsp; THE GLOBAL HUES &nbsp;</p>
            </div>
        </div>
        </div>
    </div>
    <div class="new">
      <div class="new2">
          <div class="imx">
        
              <img src="assets/images/HINDUSTAN.png" alt="">
        
          </div>
          <div class="header">
          </div>
          <div  class="new3">
            <a href="https://www.hindustantimes.com/brand-post/eureka-e-cell-iit-bombay-s-annual-b-model-competition-goes-international-101632846685703.html" target="_blank">
              <p>Eureka! – E-Cell IIT Bombay’s Annual B-Model Competition Goes International</p>
            </a>
      </div>
      <div class="knowmore">
          <div class="butbut" >
              <p class="know-more" > &nbsp; THE HINDUSTAN TIMES &nbsp;</p>
          </div>
      </div>
      </div>
  </div>
  <div class="new">
    <div class="new2">
        <div class="imx">
      
            <img src="assets/images/HINDUSTAN.png" alt="">
      
        </div>
        <div class="header">
        </div>
        <div  class="new3">
          <a href="https://www.business-standard.com/content/press-releases-ani/eureka-e-cell-iit-bombay-s-b-model-competition-hunts-for-the-next-unicorn-121101300991_1.html" target="_blank">
            <p>Eureka! - E-Cell IIT Bombay's B-model competition hunts for the next unicorn</p>
          </a>
    </div>
    <div class="knowmore">
        <div class="butbut" >
            <p class="know-more" > &nbsp; BUSINESS STANDARD &nbsp;</p>
        </div>
    </div>
    </div>
</div>
<div class="new">
  <div class="new2">
      <div class="imx">
    
          <img src="assets/images/isn.png" alt="">
    
      </div>
      <div class="header">
      </div>
      <div  class="new3">
        <a href="https://indianstartupnews.com/news/e-cell-iit-bombay-launches-eureka-road-to-enterprise-contest-2020-for-businesses-and-startups/" target="_blank">
          <p>Eureka Road To Enterprise 2020: IIT Bombay's Contest Is Live Now</p>
        </a>
  </div>
  <div class="knowmore">
      <div class="butbut" >
          <p class="know-more" > &nbsp; INDIAN STARTUP NEWS &nbsp;</p>
      </div>
  </div>
  </div>
</div>
<div class="new">
  <div class="new2">
      <div class="imx">
    
          <img src="assets/images/BHASKAR.png" alt="">
    
      </div>
      <div class="header">
      </div>
      <div  class="new3">
        <a href="https://indianstartupnews.com/news/e-cell-iit-bombay-launches-eureka-road-to-enterprise-contest-2020-for-businesses-and-startups/" target="_blank">
          <p>IIT-बॉम्बे की E-Cell ने लॉन्च किया बिजनेस मॉडल कॉम्प्टिशन Eureka!-A road to Enterprise</p>
        </a>
  </div>
  <div class="knowmore">
      <div class="butbut" >
          <p class="know-more" > &nbsp; BHASKAR &nbsp;</p>
      </div>
  </div>
  </div>
</div>
<div class="new">
  <div class="new2">
      <div class="imx">
    
          <img src="assets/images/ENTRE.png" alt="">
    
      </div>
      <div class="header">
      </div>
      <div  class="new3">
        <a href="https://www.entrepreneur.com/en-in/news-and-trends/this-iit-bombay-competition-will-ensure-entrepreneurs-find/319562" target="_blank">
          <p>Preparing Entrepreneurs For Their Own Eureka! Moment</p>
        </a>
  </div>
  <div class="knowmore">
      <div class="butbut" >
          <p class="know-more" > &nbsp; ENTREPRENEUR &nbsp;</p>
      </div>
  </div>
  </div>
</div>
<div class="new">
  <div class="new2">
      <div class="imx">
    
          <img src="assets/images/ECO.png" alt="">
    
      </div>
      <div class="header">
      </div>
      <div  class="new3">
        <a href="https://economictimes.indiatimes.com/small-biz/startups/eureka-e-cell-iit-bombays-business-model-competition-hunts-for-the-next-big-startup/articleshow/60826245.cms?from=mdr" target="_blank">
          <p>Eureka! -E-Cell IIT Bombay's business model competition hunts for the next big startup</p>
        </a>
  </div>
  <div class="knowmore">
      <div class="butbut" >
          <p class="know-more" > &nbsp; ECONOMIC TIMES &nbsp;</p>
      </div>
  </div>
  </div>
</div>

          
      </div>
     
          <!-- <div class="large-card">
            <a href="https://2k21.s3.amazonaws.com/eureka23/incentive-Sponsored_Trip_to_USA-None-.png" target="_blank" class="large-card-image">
              <img src="https://2k21.s3.amazonaws.com/eureka23/incentive-Sponsored_Trip_to_USA-None-.png" alt="Large Image" />
            </a>
            <a href="https://2k21.s3.amazonaws.com/eureka23/incentive-Sponsored_Trip_to_USA-None-.png" target="_blank" class="large-card-desc">
              <div>
                <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Perspiciatis voluptate culpa commodi dicta doloremque dolore voluptatem in expedita, nam eveniet sunt iure quidem voluptas porro, voluptatibus, deserunt molestias. Nostrum, laborum!</p>
                <div class="knowmore1">
                  <div class="butbut1">
                    <p class="know-more1">&nbsp; BUSINESS TRACK &nbsp;</p>
                    <br>
                    <p class="know-more1">&nbsp; SOCIAL TRACK &nbsp;</p>
                  </div>
                </div>
              </div>
            </a>
          </div>
           -->
        </div>
</div>
  <app-footer></app-footer>

  


